import RatingAnswer from './RatingAnswer.vue'

export default {
  RatingAnswer

}



// WEBPACK FOOTER //
// ./src/components/Rating/index.js